import { Button } from '@/ui/design-system/components/ui/button';
import CountrySelect from 'components/CountrySelect';
import { SidebarTrigger } from '@/ui/design-system/components/ui/sidebar';
import { SpateAiIcon } from '@/ui/design-system/components';
import { useAssistantContext } from 'components/AiAssistant';

function PageBar({ showCountrySelect = true, children }) {
    const { isPanelOpen, togglePanel } = useAssistantContext();
    return (
        <div className="relative z-20 flex items-center gap-4 pt-[1.15rem] pb-4">
            <SidebarTrigger className="md:hidden" />
            {children}
            <div className="grow" />
            {showCountrySelect ? <CountrySelect /> : null}
            <Button
                size="sm"
                variant="assistant"
                onClick={togglePanel}
                leftIcon={<SpateAiIcon />}
                className={isPanelOpen ? 'ring-2 ring-indigo-400/40' : ''}
            >
                Spate AI
            </Button>
        </div>
    );
}

export default PageBar;
